import { createStore as _createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createSocketIoMiddleware from 'redux-socket.io';
import { routerMiddleware } from 'react-router-redux';
import reducer from './reducer';
import loginReducer from './loginBundle/reducer';
import sagas from './sagas';
import loginSagas from './loginBundle/sagas';
import io from 'socket.io-client';
import { SOCKET_RECONNECT } from './actions';
import { actionSanitizer, stateSanitizer } from './helpers/logRocketSanitizers';

const PIPE_EVENT_TOPIC = 'action';
const PIPE_TYPE_PREFIXES = ['zen/pipe/', 'zignal-widgets/pipe/'];

function _socketIoCriteria(type, action) { // eslint-disable-line no-unused-vars
  // always execute
  return true;
}
function _socketIoExecute(maybeArrayBuffer, emit, next, dispatch) { // eslint-disable-line no-unused-vars
  let action = maybeArrayBuffer;

  if (action instanceof ArrayBuffer) {
    // Pipe communicates in binary mode
    //   also @see Util.Sockets#_onSocketMessage
    // ArrayBuffer => String
    //   http://updates.html5rocks.com/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
    //   which can produce "Uncaught RangeError: Maximum call stack size exceeded"
    //   so, here's a reliable solution ...
    const uint8Array = new Uint8Array(action);
    const charCodes = new Array(uint8Array.length);
    uint8Array.forEach((byte, index) => {
      charCodes[index] = String.fromCharCode(byte);
    });
    let json = charCodes.join('');

    try {
      // explicitly decode the String as UTF-8 for Unicode
      const { utf8 } = global;
      json = utf8.decode(json);

      // and, hydrate it
      action = JSON.parse(json);
    }
    catch (err) {
      console.log('store._socketIoExecute: received non-JSON message:', json); // eslint-disable-line no-console
      return;
    }
  }

  // now that it's hydrated, we can do some filtering
  const { type, legacy } = action;

  // FIXME: ZCC consumes "legacy" Notifications Room format from Pipe
  //   we could revert this change ...
  //   or remove this FIXME and keep it around for future needs
  if (legacy) {
    // ignore legacy format messages
    //   PS. no need for this in CoffeeScript; it doesn't subscribe to legacy-capable channels
    const json = JSON.stringify(action);
    console.log('store._socketIoExecute: ignoring legacy message:', json); // eslint-disable-line no-console
    return;
  }

  // bonus routing for Pipe `type`s
  if (PIPE_TYPE_PREFIXES.some((prefix) => type.indexOf(prefix) === 0)) {
    emit(PIPE_EVENT_TOPIC, action);
    // Forward to the CoffeeScript socket which is the actual connected socket.
    // The store's own socket gets orphaned by socket.io client caching.
    if (window.Account && window.Account.realtime) {
      window.Account.realtime.emitAction(action);
    }
  }

  next(action);
}

let socket;
let socketIoMiddleware;
let store;


export function createStore(history, data, isLoginStore = false) {

  const reduxRouterMiddleware = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [reduxRouterMiddleware];

  if (!isLoginStore) {
    const socketHost = window.location.protocol + '//' + window.location.host;
    socket = io(socketHost, {
      path: '/pipe',
      secure: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      timeout: 3000,
      autoConnect: true
    });
    socketIoMiddleware = createSocketIoMiddleware(socket, _socketIoCriteria, {
      eventName: PIPE_EVENT_TOPIC,
      execute: _socketIoExecute,
    });
    middleware.push(socketIoMiddleware);

  }

  // upstream from Socket.io messages
  middleware.push(sagaMiddleware);

  if (window.LogRocket) { // eslint-disable-line
    middleware.push(LogRocket.reduxMiddleware({ actionSanitizer, stateSanitizer }));// eslint-disable-line
  }// eslint-disable-line

  const finalCreateStore = applyMiddleware(...middleware)(_createStore);

  store = finalCreateStore(isLoginStore ? loginReducer : reducer, data);

  sagaMiddleware.run(isLoginStore ? loginSagas : sagas);

  if (socket) {
    const reconnect = () => {
      store.dispatch({ type: SOCKET_RECONNECT });
    };
    socket.on('connect', () => {
      socket.off('reconnect', reconnect);
      socket.on('reconnect', reconnect);
    });
  }

  return store;
}

export function createLoginStore(history, data) {
  return createStore(history, data, true);
}

export function destroyStore() {
  if (socket) {
    socket.close();
  }
}
